import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/material";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import { theme } from "styles/theme";
import { StartupImageScreen } from "containers/startup-image";
import { firebaseApp, FirebaseContext } from "store/firebaseContext";
import "./index.css";
import App from "App";

Sentry.init({
  dsn: "https://30edce0714ec487390c884d94f80e111@sentry.arvano.ir/11",
  integrations: [new Integrations.BrowserTracing()],
  release: process.env.REACT_APP_APP_VERSION || 'beta',
  // enabled: process.env.NODE_ENV === 'production',
  enabled: false,
  debug: process.env.NODE_ENV === 'development',
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
        <ReduxProvider store={store}>
            <PersistGate persistor={persistor} loading={<StartupImageScreen />}>
              <FirebaseContext.Provider value={firebaseApp}>
                <App />
              </FirebaseContext.Provider>
            </PersistGate>
        </ReduxProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
